<template>
  <div class="row">
    <div class="col-md-12 pad-to-5">
      <order-screen-form :route="route" @on-submit="onUserSubmit"></order-screen-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import OrderScreenForm from './OrderScreenForm.vue'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      OrderScreenForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        orderScreenModel: {},
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      onUserSubmit (model, isValid) {
        this.orderScreenModel = model
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Screens/OrderScreen/OrderScreenEdit.vue